import { Component, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TotemWidget } from '../totem-widget';
import { LocalizationService } from 'pg-lib/services/localization.service';
import { PGUtilities } from 'pg-lib/utilities/pg-utilities';

@Component({
    selector: 'app-totem-widget-viaggiare-sicuri',
    templateUrl: './totem-widget-viaggiare-sicuri.component.html',
    styleUrls: ['./totem-widget-viaggiare-sicuri.component.scss'],
    standalone: false
})
export class TotemWidgetViaggiareSicuriComponent extends TotemWidget implements OnChanges {
    
    size:'md'|'lg' = 'lg'

    constructor(public elementRef:ElementRef, private localizationService:LocalizationService) {
        super(elementRef);
    }

    @Input() country:string;
    @Input() countryName:string;
    @Input() phase:'before'|'during'|'after';
    @Input() viaggiareSicuriData:any;

    displayCountryName:string = null;

    isLoading = false;

    viewData:{
        updated: Date,
        sections: Array<{ 
            id: string, 
            titolo: string, 
            ordinamento: number, 
            nodi: Array<{ 
                titolo: string,
                contenuto: string,
                ordinamento: number,
                expanded?: boolean
            }>
        }>
    } = null;

    phaseSections: {
        [phase:string]: {
            visible: Array<string>
        }
    } = {
        'before': {
            visible: ["infoPrimopiano", "infoGenerali", "infoSicurezza", "infoSituazioneSanitaria", "infoMobilita"],
        },
        'during': {
            visible: ["infoPrimopiano", "infoGenerali", "infoSicurezza", "infoSituazioneSanitaria", "infoMobilita"],
        },
        'after': {
            visible: ["infoPrimopiano", "infoGenerali", "infoSicurezza", "infoSituazioneSanitaria", "infoMobilita"],
        }
    }

    sectionIcons: {
        [section:string]: string
    } = {
        'infoPrimopiano': 'fa-square-plus',
        'infoGenerali': 'fa-shield-check',
        'infoSicurezza': 'fa-lock',
        'infoSituazioneSanitaria': 'fa-heart',
        'infoMobilita': 'fa-car-bus',
    }

    ngOnInit(): void {
        this._refreshDisplayCountryName();
        this._buildViewData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['country'] || changes['countryName']) {
            this._refreshDisplayCountryName();
        }
        if(changes['viaggiareSicuriData'] || changes['phase']) {
            this._buildViewData();
        }
    }

    private _buildViewData() {
        if(this.viaggiareSicuriData == null) {
            this.viewData = null;
            return;
        }

        this.viewData = {
            updated: new Date(this.viaggiareSicuriData.updateDate),
            sections: []
        }

        const phaseConfig = this.phaseSections[this.phase];
        if(phaseConfig == null) return;

        for(let _index of phaseConfig.visible) {
            let _item = this.viaggiareSicuriData[_index];
            if(_item == null) continue;

            let _nodes = _item.nodi || {};
            _item.nodi = []

            for(let j in _nodes) {
                let _content = document.createElement('div');
                _content.innerHTML = _nodes[j].contenuto;

                _content.querySelectorAll('p').forEach((item) => {
                    if(item.innerHTML == '&nbsp;') {
                        _content.removeChild(item)
                    }
                })

                _nodes[j].contenuto = _content.innerHTML;
                _nodes[j].expanded = false;
                _item.nodi.push(_nodes[j])
            }

            this.viewData.sections.push(_item)
        }
    }

    private _refreshDisplayCountryName() {
        if(this.countryName) {
            this.displayCountryName = this.countryName;
            return;
        }

        const alpha2 = PGUtilities.countryAlpha3ToAlpha2(this.country);
        if(!alpha2) {
            this.displayCountryName = this.country || null;
            return;
        }

        try {
            const lang = (this.localizationService.currentLanguage || 'it_IT').split('_')[0];
            this.displayCountryName = new Intl.DisplayNames([lang], { type: 'region' }).of(alpha2) || this.country;
        }
        catch {
            this.displayCountryName = this.country || null;
        }
    }
}
